/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated, do not edit it manually",
 */

import React from "react";

import { carWirelessOffblack } from "../assets/car-wireless-offblack";
import {
  type StaticIllustrativeBaseIconProps,
  StaticIllustrativeIcon,
} from "../static-illustrative-icon";

export const IllustrativeIconCarWirelessOffblack = (props: StaticIllustrativeBaseIconProps) => (
  <StaticIllustrativeIcon {...props} svg={carWirelessOffblack.svg} />
);

IllustrativeIconCarWirelessOffblack.displayName = "IllustrativeIconCarWirelessOffblack";
